module.exports = __webpack_public_path__ + "nextjs.093227.svg";